import styled from '@emotion/styled';
import React, { FC } from 'react';
import Icon from '~ComponentsImproved/Icon';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';
import { useButton } from '~Hooks';

const OuterWrapper = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;
  align-items: center;
`;

const Wrapper = styled.div<{ selected: boolean; touching: boolean }>`
  border: 1px solid var(--colorBlueGray500);
  border-radius: 4px;
  border-color: ${({ selected }) =>
    selected ? 'var(--colorBlueGray100)' : 'var(--colorBlueGray500)'};
  border-width: ${({ selected }) => (selected ? '2px' : '1px')};
  background: transparent;
  height: 72px;
  width: 72px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: ${({ touching }) => (touching ? 'scale(0.96)' : '1')};
`;

interface Props {
  title?: string;
  iconSrc: string;
  selected: boolean;
  onClick: () => void;
}

const IconSelector: FC<Props> = ({ title, iconSrc, selected, onClick }) => {
  const iconButton = useButton({
    onClick: onClick,
  });

  return (
    <OuterWrapper>
      {title && (
        <Paragraph level={5} color="var(--colorBlueGray500)">
          {title}
        </Paragraph>
      )}
      <Wrapper selected={selected} {...iconButton}>
        <Icon
          src={iconSrc}
          color={selected ? '#fff' : 'var(--colorBlueGray500)'}
          width="60px"
          height="60px"
        />
      </Wrapper>
    </OuterWrapper>
  );
};

export default IconSelector;
